import { Box, ListItemButton, styled } from "@mui/material";
import { ediphiPalette } from "../../styles/colors";
import { SCROLLBAR_WIDTH, thinScrollbarSx } from "../../styles/scrollbar";
import { HeaderText } from "../text/HeaderText.styled";

const GROUP_BACKGROUND = "#f2f5fa";

const INSET = "11px";

export const ListContainer = styled(Box)(() => ({
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
}));

export const ListTitle = styled(HeaderText)(() => ({
  fontSize: "12px",
  paddingBottom: "4px",
}));

const listText = {
  fontSize: "12px",
  lineHeight: "18px",
};

export const ListRow = styled(ListItemButton)(() => ({
  ...listText,
  minHeight: "34px",
  padding: `6px ${INSET}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  borderBottom: `1px solid ${ediphiPalette.mainBackground}`,
  "&:hover": { backgroundColor: ediphiPalette.brand50 },
  "&.Mui-selected, &.Mui-selected:hover": { backgroundColor: ediphiPalette.brand100 },
}));

export const ListGroupRow = styled(ListRow)(() => ({
  alignItems: "center",
  justifyContent: "flex-start",
  fontWeight: 700,
  borderBottomColor: ediphiPalette.white,
  "&:hover": { backgroundColor: GROUP_BACKGROUND },
  backgroundColor: GROUP_BACKGROUND,
}));

export const ListLabel = styled(Box)(() => ({
  minWidth: 0,
  overflowWrap: "anywhere",
}));

export const ListMessage = styled(Box)(() => ({
  ...listText,
  color: ediphiPalette.greyText,
  padding: `12px ${INSET}`,
}));

export const ListSkeletonArea = styled(Box)(() => ({
  padding: `0px ${INSET}`,
  minHeight: "22px",
  display: "flex",
  flexDirection: "column",
}));

/**
 * Holds the scrollbar but carries no surface styling, so the bar is drawn over the drawer
 * rather than over the list. The negative margin reclaims exactly the bar's width from the
 * parent's padding, which leaves this element's *content box* — and so ListSurface — ending on
 * the same line the padding would have. That is what keeps row backgrounds reaching the card
 * edge symmetrically.
 */
export const ListScrollArea = styled(Box)(() => ({
  ...thinScrollbarSx,
  flex: 1,
  minHeight: 0,
  // `scroll`, not `auto` — the negative margin below assumes the track always exists.
  overflowY: "scroll",
  marginRight: `-${SCROLLBAR_WIDTH}px`,
}));

export const ListSurface = styled(Box)(() => ({
  borderRadius: "4px",
  backgroundColor: ediphiPalette.white,
}));
